import { createAction, handleActions } from 'redux-actions';
import { _getAddOnServicesList, _addNewAddOnService, _editAddOnService, _deleteAddOnService, _getActiveAddOnServicesList } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';
import { _getAddOnServiceListByPagination } from '../../../shared/httpService/apis';

const initialState = {
  add_on_services: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
  add_new_add_on_service: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  edit_add_on_service: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  delete_add_on_service: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  active_add_on_services: {
    loading: false,
    response: {},
    hasError: false,
    error: {}
  },
  add_on_services_paginated: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },

};

export const getAddOnServicesListStart = createAction(ActionTypes.GET_ADD_ON_SERVICES_LIST);
export const getAddOnServicesListSuccess = createAction(ActionTypes.GET_ADD_ON_SERVICES_LIST_SUCCESS, response => response);
export const getAddOnServicesListError = createAction(ActionTypes.GET_ADD_ON_SERVICES_LIST_ERROR, error => error);

export const getAddOnServicesList = (page = '', pageSize, search = '') => (dispatch) => {
  dispatch(getAddOnServicesListStart());
  return _getAddOnServicesList(page, pageSize, search).then((response) => {
    dispatch(getAddOnServicesListSuccess(response));
  }).catch((error) => {
    dispatch(getAddOnServicesListError(error));
  });
};

export const addNewAddOnServiceStart = createAction(ActionTypes.ADD_NEW_ADD_ON_SERVICE);
export const addNewAddOnServiceSuccess = createAction(ActionTypes.ADD_NEW_ADD_ON_SERVICE_SUCCESS, response => response);
export const addNewAddOnServiceError = createAction(ActionTypes.ADD_NEW_ADD_ON_SERVICE_ERROR, error => error);

export const addNewAddOnService = (data) => (dispatch) => {
  dispatch(addNewAddOnServiceStart());
  return _addNewAddOnService(data).then((response) => {
    dispatch(addNewAddOnServiceSuccess(response));
  }).catch((error) => {
    dispatch(addNewAddOnServiceError(error));
  });
};

export const editAddOnServiceStart = createAction(ActionTypes.EDIT_ADD_ON_SERVICE);
export const editAddOnServiceSuccess = createAction(ActionTypes.EDIT_ADD_ON_SERVICE_SUCCESS, response => response);
export const editAddOnServiceError = createAction(ActionTypes.EDIT_ADD_ON_SERVICE_ERROR, error => error);

export const editAddOnService = (id, data) => (dispatch) => {
  dispatch(editAddOnServiceStart());
  return _editAddOnService(id, data).then((response) => {
    dispatch(editAddOnServiceSuccess(response));
  }).catch((error) => {
    dispatch(editAddOnServiceError(error));
  });
};

export const deleteAddOnServiceStart = createAction(ActionTypes.DELETE_ADD_ON_SERVICE);
export const deleteAddOnServiceSuccess = createAction(ActionTypes.DELETE_ADD_ON_SERVICE_SUCCESS, response => response);
export const deleteAddOnServiceError = createAction(ActionTypes.DELETE_ADD_ON_SERVICE_ERROR, error => error);

export const deleteAddOnService = (id) => (dispatch) => {
  dispatch(deleteAddOnServiceStart());
  return _deleteAddOnService(id).then((response) => {
    dispatch(deleteAddOnServiceSuccess(response));
  }).catch((error) => {
    dispatch(deleteAddOnServiceError(error));
  });
};

export const getActiveAddOnServicesListStart = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST);
export const getActiveAddOnServicesListSuccess = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST_SUCCESS, response => response);
export const getActiveAddOnServicesListError = createAction(ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST_ERROR, error => error);

export const getActiveAddOnServicesList = (page = '') => (dispatch) => {
  dispatch(getActiveAddOnServicesListStart());
  return _getActiveAddOnServicesList(page).then((response) => {
    dispatch(getActiveAddOnServicesListSuccess(response));
  }).catch((error) => {
    dispatch(getActiveAddOnServicesListError(error));
  });
};





export const getActiveAddOnServicesPaginatedListStart = createAction(ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED);
export const getActiveAddOnServicesPaginatedListSuccess = createAction(ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED_SUCCESS, response => response);
export const getActiveAddOnServicesPaginatedListError = createAction(ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED_ERROR, error => error);

export const getAddOnServicesListByPagination = (pageNo, pageSize, inputValue) => (dispatch) => {
  dispatch(getActiveAddOnServicesPaginatedListStart());
  return _getAddOnServiceListByPagination(pageNo, pageSize, inputValue).then((response) => {
    dispatch(getActiveAddOnServicesPaginatedListSuccess(response));
  }).catch((error) => {
    dispatch(getActiveAddOnServicesPaginatedListError(error));
  });
};

const reducer = handleActions({

  //ADD_ON_SERVICES_LIST_BY_PAGINATED
  [ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED]: (state) => ({
    ...state, add_on_services_paginated: {
      ...state.add_on_services_paginated,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED_SUCCESS]: (state, action) => ({
    ...state,
    add_on_services_paginated: {
      ...state.add_on_services_paginated
      ,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ADDON_SERVICE_LIST_PAGINATED_ERROR]: (state, action) => ({
    ...state,
    add_on_services_paginated: {
      ...state.add_on_services_paginated,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ADD_ON_SERVICES_LIST
  [ActionTypes.GET_ADD_ON_SERVICES_LIST]: (state) => ({
    ...state, add_on_services: {
      ...state.add_on_services,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ADD_ON_SERVICES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    add_on_services: {
      ...state.add_on_services,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ADD_ON_SERVICES_LIST_ERROR]: (state, action) => ({
    ...state,
    add_on_services: {
      ...state.add_on_services,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //ADD_NEW_ADD_ON_SERVICE
  [ActionTypes.ADD_NEW_ADD_ON_SERVICE]: (state) => ({
    ...state, add_new_add_on_service: {
      ...state.add_new_add_on_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_ADD_ON_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    add_new_add_on_service: {
      ...state.add_new_add_on_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.ADD_NEW_ADD_ON_SERVICE_ERROR]: (state, action) => ({
    ...state,
    add_new_add_on_service: {
      ...state.add_new_add_on_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //EDIT_ADD_ON_SERVICE
  [ActionTypes.EDIT_ADD_ON_SERVICE]: (state) => ({
    ...state, edit_add_on_service: {
      ...state.edit_add_on_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_ADD_ON_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    edit_add_on_service: {
      ...state.edit_add_on_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.EDIT_ADD_ON_SERVICE_ERROR]: (state, action) => ({
    ...state,
    edit_add_on_service: {
      ...state.edit_add_on_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //DELETE_ADD_ON_SERVICE
  [ActionTypes.DELETE_ADD_ON_SERVICE]: (state) => ({
    ...state, delete_add_on_service: {
      ...state.delete_add_on_service,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_ADD_ON_SERVICE_SUCCESS]: (state, action) => ({
    ...state,
    delete_add_on_service: {
      ...state.delete_add_on_service,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.DELETE_ADD_ON_SERVICE_ERROR]: (state, action) => ({
    ...state,
    delete_add_on_service: {
      ...state.delete_add_on_service,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

  //ACTIVE_ADD_ON_SERVICES
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST]: (state) => ({
    ...state, active_add_on_services: {
      ...state.active_add_on_services,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    active_add_on_services: {
      ...state.active_add_on_services,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_ADD_ON_SERVICES_LIST_ERROR]: (state, action) => ({
    ...state,
    active_add_on_services: {
      ...state.active_add_on_services,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);

export default reducer;